import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../../components/Hooks/useFetchObjectByPost";
import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import { sto } from "../../../../../Context/InshData";
import { uri } from "../../../../../help/Api";
import HashLoader from "react-spinners/HashLoader";
import { colors, Container, Dialog, Modal } from "@material-ui/core";
import LoadingPage from "../../../../../services/LoadingPage";
import AddItems from "./addItems";
const defaultAutos = {
  Branches: [],
};

export default function ItemsDialog(props) {
  const { open, onClose, itemdata} = props;
  const tb = {
    wait: true,
    other: true,
    GetFoundation: true,
    Groupst: true,
    groups: true,
    AllBranches: true,
    tax_groups: true,
    Units: true,
    Items: true,
    PermissionsTypeInv: true,
    PermissionsCuCo: true,
    groupSubAll: true,
    parms: {
      iempid: sto.empi,
      fltrBranch: true,
      scurrenciestype: "C",
      tname: "curr",
      takei: 40,
      iformidCuCo: 10004,
      iformid: 40002,
      ibranchid: sto.branchi,
      branch: sto.branchi,
      iFoundid: 1,
      db_name:sto?.db_name
    },
    autos: {},
  };


  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
  );

  if (
    fetchAll ||
    !AutoOptions?.Branches
  )
    return <LoadingPage />;

  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <AddItems
        {...{
          AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
          locat: {},
          isDialog: true,
          DialogClose: false,
          onClose,
          itemdata,
          fromExcel:false,
        }}
      />
    </Dialog>

  )
}
